import React, { useState, useEffect } from 'react'
import './NavBar.css'
import Logo from '../Images/newlogo.svg'
import { Link } from 'react-router-dom'
import { useLocation } from './LocationContext';
import icoSix from '../Images/ico6.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faBars } from '@fortawesome/free-solid-svg-icons';

function NavBarTwo() {
   const [open, setOpen] = useState(false)
  const { location, currency } = useLocation();
  const [theFlag, setTheFlag] = useState();

  // Update the flag state when currency changes
  useEffect(() => {
    if (currency?.flag) {
      setTheFlag(currency.flag);
    }
  }, [currency]);


  return (
    <div className='navBar'>
      <img src={Logo} className='logo' alt='' />

      <div className={open ? 'navLinks open' : 'navLinks'}>
        <ul>
          <li className='listItems'><a href='/'>Home</a></li>
          <li className='listItems'><a href='/#about'>About Us</a></li>
          <li className='listItems'><a href='/#how-we-work'>How we work</a></li>
          <li className='listItems'><a href='/#contact-us'>Contact us</a></li>
        </ul>

        {/* <Link className='signInBtn' to='/login'>Sign In</Link> */}
        <Link to="/login" className="newLoginBtns">
          <span className="countryCont2">
            {theFlag ? <img src={theFlag} alt="Flag" /> : <img src={icoSix} alt="Default icon" />}
          </span>
          <span>Login</span>
          <FontAwesomeIcon icon={faArrowRight} className="newLoginbtnsRight" />
        </Link>



      </div>


      <div className='navLinksCont'>
        <Link to="/login" className="newLoginBtns hidethisthing">
          <span className="countryCont2">
            {theFlag ? <img src={theFlag} alt="Flag" /> : <img src={icoSix} alt="Default icon" />}
          </span>
          <span>Login</span>
          <FontAwesomeIcon icon={faArrowRight} className="newLoginbtnsRight" />
        </Link>

        <div className='hamburger' onClick={() => setOpen(!open)}>
          <div className='bar'></div>
          <div className='bar'></div>
          <div className='bar'></div>
        </div>
      </div>

    </div>


  )
}

export default NavBarTwo